
import React from 'react'
import icon from './svgs/click.svg'
import { BaseIcon } from './_base'

export const ClickIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
